import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CustomeEmailTemplateService } from './custom-email-template.service';
import { PackageEmailTemplate } from '../../Processing/Transmittal/transmittal.models';
import { TimerService } from '../../UI-Lib/Utilities/timer.service';
import { UtilitiesService } from 'src/app/UI-Lib/Utilities';

declare const $: any;

@Component({
    selector: 'custom-email-template-modal',
    templateUrl: './custom-email-template-modal.component.html',
    standalone: false
})
export class CustomEmailTemplateModalComponent implements OnInit {
    constructor(public bsModalRef: BsModalRef,
                private readonly _customEmailTemplateService: CustomeEmailTemplateService,
                private readonly _timer: TimerService) {
    }

    onClose: any;
    template: any;
    packageEmailTemplates: PackageEmailTemplate[];
    selectedEmailTemplate: PackageEmailTemplate;
    emailTemplateFields: any = {};
    editorInstance: any;


    ngOnInit() {
        this._customEmailTemplateService.getEmailTemplateFields()
            .then((result) => {
                const sortedResults = _.sortBy(result, 'name');

                this.emailTemplateFields.body = sortedResults;
                this.emailTemplateFields.subject = _.filter(sortedResults, 'validInSubject');
            });

        this._timer.setTimeout(() => {
            $('#custom-template-subject').focus();
        });
    }

    addBindingCreated(quillInstance): void {
        this.editorInstance = quillInstance;
    }

    insertFieldInBody(field): void {
        const cursorPosition: number = this.editorInstance.getSelection(true).index;
        const fieldName: string = `{{ ${field.name} }}`;

        this.editorInstance.insertText(cursorPosition, fieldName);
    }

    // http://jsfiddle.net/4abr7jc5/2/
    insertFieldInSubject(field): void {
        const cursorPosStart = $('#custom-template-subject').prop('selectionStart');
        const cursorPosEnd = $('#custom-template-subject').prop('selectionEnd');
        const v = $('#custom-template-subject').val();
        const textBefore = v.substring(0, cursorPosStart);
        const textAfter = v.substring(cursorPosEnd, v.length);
        const fieldName = `{{ ${field.name} }}`;

        $('#custom-template-subject').val(textBefore + fieldName + textAfter);
        this.template.packageEmailCustomTemplateSubject = $('#custom-template-subject').val();

        $('#custom-template-subject').focus();
    }

    baseTemplateChange(event): void {
        const oldSelectedTemplate: PackageEmailTemplate = _.cloneDeep(this.selectedEmailTemplate);

        if (this.template.packageEmailCustomTemplateBody || this.template.packageEmailCustomTemplateSubject) {
            if (confirm('Changing the base template will overwrite any current values. Do you wish to continue?')) {
                this.selectedEmailTemplate = event;
                this.copySelectedTemplateFields();
            } else {
                this.selectedEmailTemplate = _.cloneDeep(oldSelectedTemplate);
            }
        } else {
            this.selectedEmailTemplate = event;
            this.copySelectedTemplateFields();
        }
    }

    copySelectedTemplateFields(): void {
        this.template.packageEmailCustomTemplateSubject = this.selectedEmailTemplate.subjectTemplate;
        this.template.packageEmailCustomTemplateBody = this.selectedEmailTemplate.bodyTemplate;
    }

    closeModal(template?): void {
        if (template && template.packageEmailCustomTemplateBody) {
            template.packageEmailCustomTemplateBody = UtilitiesService.patchQuillHtml(template.packageEmailCustomTemplateBody);
        }
        this.onClose(template);
        this.bsModalRef.hide();
    }
}
